import React from 'react';
import Utils from './Utils';

import { GridspaceLoadingIcon, InputFileBox, FlexForm, FormField, ScriptText, SessionTextArea, SubmitRow } from './Components'


class DaynaGenerateScript extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requirements: "", 
      yaml: "",
      yamlEnc: "",
      script: "", 
      scriptname: "",
      generating: false,
      prompt: "",
      message: ""
    }
  }

  componentDidMount() {
  }

  storeSelectedFile(e) {
    e.preventDefault();
    e.stopPropagation();

    let reader = new FileReader();
    let storeContent = (c) => {
      this.setState({yamlEnc: c});
    };
    reader.onload = (event) => {
        storeContent(event.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({generating: true});

    // Check that at least one of requirements/yaml have been submitted
    if (!this.state.requirements && !this.state.yaml) {
      this.setState({message: "Must provide a requirements description or playbook file to generate a script!", generating: false});
      return;
    };

    let data = {
      'requirements': this.state.requirements,
      'yaml': this.state.yaml,
      'encoded_yaml': this.state.yamlEnc
    };

    Utils.apiPost("/dayna/new_script", data)
      .then((response) => {
          this.setState({script: response.data["script"], prompt: response.data["prompt"], generating: false, message: ""})
        }
      )
  };

  handleSave(e) {
    e.preventDefault();
    e.stopPropagation();

    let data = {
      'scriptname': this.state.scriptname, 
      'script': this.state.script, 
    };
    Utils.apiPost("/dayna/new_script", data)
      .then((response) => {
          this.setState({message: response.data["message"]})
        }
      )
  };

  render() {
    const { requirements, scriptname, yaml } = this.state;
    return (
        <FlexForm>
          <FormField label='Enter the name for the script:'>
            <SessionTextArea
              style={{'height': '25px', 'width': '500px'}}
              name="name"
              placeholder="e.g. Vinitas Eleven First Names"
              value={scriptname}
              onChange={(event) => {this.setState({ scriptname: event.target.value })}}
            />
          </FormField>
          <FormField label='Enter the requirements for the script:'>
            <SessionTextArea
              style={{'height': '55px', 'width': '500px'}}
              name="requirements"
              placeholder="e.g. Generate sentences containing the names Venkata, Satya, Sai, Naga, Rama, Koti, Erni, Surya, Lakshmi, Pydi, and Vinita."
              value={requirements}
              onChange={(event) => {this.setState({ requirements: event.target.value })}}
            />
          </FormField>
          <FormField label='Upload a playbook YAML file:'>
            <InputFileBox
              style={{'width': '500px'}}
              name="yaml"
              type="file" 
              accept=".yml, .yaml"
              value={yaml}
              onChange={(event) => {this.setState({ yaml: event.target.value }); this.storeSelectedFile(event)}}
            />
          </FormField>
          {!this.state.generating &&
            <SubmitRow>
              <button type="submit" onClick={e => this.handleSubmit(e)}>
                Generate
              </button>
            </SubmitRow>
          }
          {this.state.generating && <GridspaceLoadingIcon />}
          {!this.state.generating && this.state.script && 
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
              <ScriptText 
                label="Script"
                text={this.state.script.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"")}
                onChange={(event) => {this.setState({ script: event.target.value })}}
              />
              <SubmitRow>
                <button type="submit" onClick={e => this.handleSave(e)}>
                  Save Script
                </button>
              </SubmitRow>
              <div style={{width: "500px", marginTop: "16px", marginBottom: "16px"}}>
                <hr/>
                <h3>Prompt:</h3>
                <a style={{whiteSpace: "pre-line"}}>{this.state.prompt}</a>
              </div>
            </div>
          }
          <h3>{this.state.message}</h3>
        </FlexForm>
    );
  }
}

export default DaynaGenerateScript;